import { LockKeyhole, LogOut } from "lucide-react";

type TopbarProps = {
  operatorMode: boolean;
  onHome: () => void;
  onExit: () => void;
  onLogin: () => void;
};

/** Shared compact application header used by storefront and operator views. */
export function Topbar({ operatorMode, onHome, onExit, onLogin }: TopbarProps) {
  return (
    <header className="topbar">
      <button className="wordmark" type="button" aria-label="YooY 首页" onClick={onHome}>
        <img className="brand-logo" src="/yoyo-logo.svg" alt="" aria-hidden="true" />
        <span className="sr-only">YooY</span>
      </button>
      {operatorMode ? (
        <button className="icon-button" type="button" aria-label="退出账户中心" onClick={onExit}>
          <LogOut size={16} />
        </button>
      ) : (
        <button className="icon-button" type="button" aria-label="登录或查询订单" onClick={onLogin}>
          <LockKeyhole size={16} />
        </button>
      )}
    </header>
  );
}
